import { useEffect, useState } from "react";
import "./DropDownList.scss";
import DropdownList from "react-widgets/DropdownList";
import "react-widgets/scss/styles.scss";
import UtilServices from "@services/UtilServices";
import { Tooltip } from "react-tooltip";
import ButtonIcon from "@components/buttonIcon/ButtonIcon";

/*DOCUMENTAÇÃO
    https://jquense.github.io/react-widgets/docs/DropdownList 
*/

export default function DropDownList(props) {
  const [dataSlice, setDataSlice] = useState([]);

  useEffect(() => {
    if (props.data.length > 1000) {
      setDataSlice(props.data.slice(0, 100));
    }
  }, [props.data]);

  const onReturn = (value) => {
    if (props.register !== null) {
      props.onChange(props.name, value[props.textField], value);
      return;
    }
    return props.onChange(value);
  };

  const handleChange = (e) => {
    return onReturn(e);
  };

  const handleSearch = (value) => {
    const datafilter = props.data.filter((item) =>
      Object.values(item).some((val) =>
        String(val).toLowerCase().includes(value.toLowerCase()),
      ),
    );
    setDataSlice(datafilter.slice(0, 100));
  };

  const handleToggle = (isOpen) => {
    if (isOpen) {
      props.functionCarregarClick();
    }
  };

  return (
    <div
      className={`dropdownlist ${props.className} theme${props.theme}`}
      {...(props.register && {
        ...props.register(props?.name, {
          required: props?.required,
          ...props?.registerProps,
        }),
      })}
    >
      <div style={{ display: "flex" }}>
        {props.title && <p>{props.title}</p>}
        {props.tooltip && (
          <p
            data-tooltip-id={props.tooltipId}
            data-tooltip-content={props.tooltipDescricao}
            className="tooltipInput"
            style={{ color: props.tooltipIconColor, cursor: "pointer" }}
          >
            {props.tooltipIcon}
          </p>
        )}
      </div>
      <div
        className={`${props.disabled ? "disabled" : ""}`}
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          gap: "10px",
        }}
      >
        <DropdownList
          dataKey={props.dataKey}
          textField={props.textField}
          value={props.value}
          placeholder={props.placeholder}
          onChange={handleChange}
          defaultValue={props.defaultValue}
          data={props.data.length > 1000 ? dataSlice : props.data}
          busy={props.loading}
          disabled={props.dataDisabled}
          readOnly={props.disabled}
          onSearch={handleSearch}
          filter="contains"
          {...(props.flgCarregarClick && {
            onToggle: handleToggle, //Validação de um campo que não pode ser nulo aqui fora.
          })}
        />
        {props?.button && (
          <ButtonIcon
            {...{
              //Tipo de botão
              [props.iconButton]: true,
              // title
              [`title${
                props.iconButton.charAt(0).toUpperCase() +
                props.iconButton.slice(1)
              }`]: props.titleButton,
              // on
              [`on${
                props.iconButton.charAt(0).toUpperCase() +
                props.iconButton.slice(1)
              }`]: props.onClickButton,
              //type
              [`type${
                props.iconButton.charAt(0).toUpperCase() +
                props.iconButton.slice(1)
              }`]: props.typeButton,
              //disabled
              [`disabled${
                props.iconButton.charAt(0).toUpperCase() +
                props.iconButton.slice(1)
              }`]: props.disabled,
            }}
          />
        )}
      </div>
      {props.required && props.errors && props.errors[props.name] && (
        <span className="dropdownMsgError">
          {props.errors[props.name].message}
        </span>
      )}
    </div>
  );
}

DropDownList.defaultProps = {
  dataKey: "id",
  textField: "key",
  data: [
    { id: 0, key: "CPF" },
    { id: 1, key: "CNPJ" },
    { id: 2, key: "Razão Social" },
    { id: 3, key: "Nome Fantasia" },
  ],
  dataDisabled: [], //passar os nome para desativar.
  disabled: false, //Desativa totalmente
  type: "text",
  placeholder: "",
  value: "",
  title: "",
  onChange: () => null,
  className: "",
  theme: "1",
  defaultValue: "",
  loading: false,
  name: "", //Item para campo obrigatorio
  required: false, //Item para campo obrigatorio
  register: null, //Item para campo obrigatorio
  registerProps: {}, //Item para campo obrigatorio
  errors: null, //Item para campo obrigatorio
  requiredUseValue: false, //Item para usar o value/change
  //Button
  button: false,
  iconButton: "pesquisar",
  titleButton: "",
  typeButton: "button",
  onClickButton: () => null,
  //ToolTip
  tooltip: false,
  tooltipId: "",
  tooltipIcon: <i className="fa-solid fa-hexagon-exclamation"></i>,
  tooltipDescricao: "",
  tooltipIconColor: "#ff7575c9",
  //Carregar ao click
  flgCarregarClick: false,
  functionCarregarClick: () => null,
};
